export default __webpack_public_path__ + "static/media/arrow-matches.ddde9e55.svg";